module.exports = __webpack_public_path__ + "img/DriveEtaOutlined.68ca43d8.svg";